<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    datas: { type: Object, default: {} },
    maxPerPage: { type: Number, required: true },
  },

  data() {
    return {
      current: 0,
      list: '',
    }
  },

  watch: {
    current: {
      handler() {
        this.listRender()
      },
    },
    maxPerPage: {
      handler() {
        this.listRender()
      },
    },
  },

  computed: {
    total: {
      cache: true,
      get() {
        let number = Math.ceil(this.datas.length / this.maxPerPage)

        return number
      },
    },
    pages: {
      get() {
        const pages = []
        for (let i = -3; i <= 3; i++) {
          if (this.current + i > 0 && this.current + i <= this.total) {
            pages.push(this.current + i)
          }
        }
        return pages
      },
    },
  },

  methods: {
    listRender: function () {
      this.list = this.datas.slice((this.current - 1) * this.maxPerPage, this.current * this.maxPerPage)
      this.$emit('show-list', this.list)
    },

    previousPage: function () {
      if (this.current > 1) {
        this.current--
      }
    },

    currentPage: function (number) {
      this.current = number
    },

    nextPage: function () {
      if (this.current < this.total) {
        this.current++
      }
    },
  },

  mounted: function () {
    this.current = 1
  },
}
</script>
<template>
  <div>
    <ul class="d-flex pagination__list">
      <li class="pagination__detail"><button class="btn btn-infos" @click="previousPage()">Précédent</button></li>
      <li v-if="current > 4" class="pagination__detail">
        <button :class="'btn btn-' + (current == 1 ? 'info' : 'primary')" @click="currentPage(1)">1</button>
      </li>
      <li v-if="current > 5" class="pagination__detail">
        <button class="btn btn-infos">...</button>
      </li>
      <li v-for="n in pages" class="pagination__detail">
        <button :class="'btn btn-' + (n == current ? 'info' : 'primary')" @click="currentPage(n)">{{ n }}</button>
      </li>
      <li v-if="current <= total - 5" class="pagination__detail">
        <button class="btn btn-infos">...</button>
      </li>
      <li v-if="current <= total - 4" class="pagination__detail">
        <button :class="'btn btn-' + (current == total ? 'info' : 'primary')" @click="currentPage(total)">
          {{ total }}
        </button>
      </li>
      <li class="pagination__detail"><button class="btn btn-infos" @click="nextPage()">Suivant</button></li>
    </ul>
  </div>
</template>
